import { Flex, Hide } from '@chakra-ui/react';

import { Header } from '../../components';

import { SummaryMyProducts } from './SummaryMyProducts';
import { SummaryPurchaseData } from './SummaryPurchaseData';

const ROOT_ENTITY = 'checkout/data';

export const Summary = () => {
  return (
    <Flex
      flexDir="column"
      w="full"
      p={{ base: 0, lg: 5 }}
      maxH="100dvh"
      h="100dvh"
    >
      <Header currentStep={4} rootEntity={ROOT_ENTITY} />

      <Flex
        gap={5}
        flexDir={{ base: 'column', lg: 'row' }}
        p={{ base: 4, lg: 0 }}
      >
        <Flex flexDir="column" gap={6} w="full">
          <SummaryPurchaseData />
        </Flex>
        <Hide below="lg">
          <SummaryMyProducts />
        </Hide>
      </Flex>
    </Flex>
  );
};
